/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

const validateCollection = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = 'The title is required';
  }
  if (!values.description) {
    errors.description = 'The description is required';
  }
  if (values.status === 'published') {
    if (!values.imageUrl) {
      errors.status = 'To publish a collection you must provide an image';
    }
    if (!values.assets || values.assets.length < 1) {
      errors.status =
        'To publish a collection you must have at least one asset in you collection';
    }
  }
  return errors;
};

export default validateCollection;
